<div class="grid-x grid-margin-x margin-bottom">
	<div class="cell large-12 text-align-right">
		<button class="button" [disabled]="isEdit" (click)="createPdf()">Download PDF</button>
	</div>
</div>
@if (!isEdit) {
<div class="grid-x grid-margin-x margin-bottom">
	<div class="cell large-12 italic">
		Positioning of headers and footers in the HTML preview below may not reflect their positioning in the printed document.  Please preview the PDF using the "Download PDF" button for a preview of the final printed document.
	</div>
</div>
<div class="grid-x grid-margin-x">
	<div class="cell large-12">
		Documents uploaded elsewhere in the flow will @if (!this.componentData.config.pdfOptions.mergeDocuments) {
		NOT
		} be merged into the final generated PDF.
	</div>
	@if (this.componentData.config.pdfOptions.mergeDocuments && this.componentData.config.pdfOptions.useCustomHeader) {
	<div class="cell large-12">
		The header below will be imprinted onto all merged documents:
	</div>
	<div class="cell large-12">
		{{compiledCustomHeader}}
	</div>
	}
</div>
  @if (pdfError.length === 0) {
	<ngx-extended-pdf-viewer [src]="pdfUrl" [textLayer]="false" [showAll]="true" [showToolbar]="false" [pageViewMode]="'infinite-scroll'"></ngx-extended-pdf-viewer>
  }
{{pdfError}}
}
@if (isEdit) {
{{html}}
  @if (html === ' ') {
<span class="builder-warning border-none no-padding normal">
	No HTML template has been configured
</span>
  }
}


